import React from 'react';
import { ClockIcon, CreditCardIcon, LockIcon } from 'lucide-react';
import { OfferBlock } from './OfferBlock';
import { useCountdown } from '../hooks/useCountdown';
export function FinalCta() {
  const {
    hours,
    minutes,
    seconds,
    expired
  } = useCountdown(23.75);
  return <section id="offer" aria-labelledby="offer-heading" className="bg-navy-950" data-id="element-47" data-mp="15dlu8ylzewt5">
      <div className="mx-auto max-w-content px-4 py-20 sm:px-6 lg:py-28" style={{
      paddingTop: "30px",
      paddingBottom: "30px"
    }} data-id="element-48" data-mp="15fq5k1m7my3g">
        <div className="mx-auto max-w-3xl text-center" data-id="element-49" data-mp="1ed0ma2hsrffr">
          <h2 id="offer-heading" className="font-display text-[2.15rem] font-extrabold leading-[1.03] tracking-tight text-white sm:text-5xl" data-id="element-50" data-mp="1t2ycsp378h84">
            এমন ২,৮৪৭ জনেরও বেশি উচ্চাকাঙ্ক্ষী তরুণ বাংলাদেশির দলে যোগ দিন, যারা ইতিমধ্যেই নিজেদের জীবন বদলে ফেলছেন।
          </h2>
          

          <OfferBlock className="mt-10" data-id="element-51" data-mp="221a12kglf2xe" />

          <div className="mx-auto mt-10 max-w-xl rounded-xl border border-white/10 bg-navy-900 px-6 py-5" style={{
          paddingTop: "0px",
          paddingBottom: "0px"
        }} data-id="element-52" data-mp="1x5b80jkbkwqn">
            <p className="flex flex-wrap items-center justify-center gap-2 text-sm text-white/75" data-id="element-53" data-mp="s45s82ltnfu8">
              <ClockIcon className="h-4 w-4 text-sun" aria-hidden="true" data-id="element-54" data-mp="x38yfqdjfs3s" />
              {expired ? <span data-id="element-55" data-mp="122lm2dc8h37f">
                  এই বিশেষ মূল্য শেষ হচ্ছে{' '}
                  <span className="font-semibold text-white" data-id="element-56" data-mp="120semvtsqeyd">আজই</span>
                </span> : <>
                  এই বিশেষ মূল্য শেষ হচ্ছে
                  <span className="font-display font-bold tabular-nums text-white" data-id="element-57" data-mp="1b31pxnww2cct">
                    {hours}:{minutes}:{seconds}
                  </span>
                  পরে
                </>}
            </p>
            <p className="mt-3 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-white/50" data-id="element-58" data-mp="1ksbewuwfrewp">
              <span className="flex items-center gap-1.5" data-id="element-59" data-mp="1ptqyeiiytdcz">
                <CreditCardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-60" data-mp="1ttroj0fffczv" />
                ১০০% সিকিউর পেমেন্ট
              </span>
              <span className="flex items-center gap-1.5" data-id="element-61" data-mp="3qvgss5cporf5">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-62" data-mp="3lvuedsl5d54r" />
                আপনার তথ্য সুরক্ষিত
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}